import { HeaderState } from "../../Models/RightSidebarState";
import { SET_HEADER_BREADCRUMB, SET_HEADER_FILE_NAME, SET_HEADER_QUESTION_TITLE } from "./HeaderTypes";

const initialState: HeaderState = {
  loading: false,
  question: "",
  fileName: null,
  breadcrumb: null,
  error: null,
};

const HeaderReducer = (state = initialState, action: any): HeaderState => {
  switch (action.type) {
    case SET_HEADER_QUESTION_TITLE:
      return { ...state, question: action.payload };
    case SET_HEADER_FILE_NAME:
      return { ...state, fileName: action.payload };
    case SET_HEADER_BREADCRUMB:
      return { ...state, breadcrumb: action.payload };
    default:
      return state;
  }
};

export default HeaderReducer;
